import { render, staticRenderFns } from "./AsignarEncargadoProveedor.vue?vue&type=template&id=28f201d8&scoped=true&"
import script from "./AsignarEncargadoProveedor.vue?vue&type=script&lang=js&"
export * from "./AsignarEncargadoProveedor.vue?vue&type=script&lang=js&"
import style0 from "./AsignarEncargadoProveedor.vue?vue&type=style&index=0&id=28f201d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f201d8",
  null
  
)

export default component.exports